import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import {
  FiPhone,
  FiVideo,
  FiEdit3,
  FiCheckSquare,
  FiCpu,
  FiCode,
  FiType,
  FiArrowRight,
} from 'react-icons/fi';
import { INTERVIEW_MODES, MODE_FAMILIES, MODE_PUBLIC_LEAD } from '../utils/interviewModes';

const MODE_ICONS = {
  FiPhone,
  FiVideo,
  FiEdit3,
  FiCheckSquare,
  FiCpu,
  FiCode,
  FiType,
};

const Wrap = styled.section`
  max-width: 1200px;
  margin: 0 auto;
`;

const Lead = styled.p`
  text-align: center;
  color: #475569;
  line-height: 1.7;
  max-width: 720px;
  margin: 0 auto 2rem;
  font-size: clamp(1rem, 2.4vw, 1.1rem);
`;

const FamilyBlock = styled.div`
  margin-bottom: 2rem;
`;

const FamilyHead = styled.div`
  margin-bottom: 1rem;
`;

const FamilyTitle = styled.h3`
  font-size: 1.15rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 0.25rem;
`;

const FamilySub = styled.p`
  margin: 0;
  color: #64748b;
  font-size: 0.95rem;
  line-height: 1.5;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 240px), 1fr));
  gap: 1rem;
`;

const Card = styled.article`
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  padding: 1.15rem 1.2rem 1.25rem;
  min-width: 0;
`;

const CardTop = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  margin-bottom: 0.65rem;
`;

const IconWrap = styled.div`
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  border-radius: 10px;
  background: #0f766e;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const CardTitle = styled.h4`
  margin: 0;
  font-size: 1.02rem;
  color: #0f172a;
  font-weight: 650;
`;

const Meta = styled.span`
  display: block;
  margin-top: 0.15rem;
  font-size: 0.78rem;
  color: #0f766e;
  font-weight: 600;
`;

const CardBody = styled.p`
  margin: 0;
  color: #64748b;
  font-size: 0.9rem;
  line-height: 1.55;
`;

const When = styled.p`
  margin: 0.7rem 0 0;
  color: #334155;
  font-size: 0.82rem;
  line-height: 1.45;
`;

const Cta = styled(Link)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  margin: 0.25rem auto 0;
  background: #0f766e;
  color: #fff;
  text-decoration: none;
  font-weight: 600;
  padding: 0.85rem 1.25rem;
  border-radius: 12px;
  max-width: 100%;
  text-align: center;

  &:hover {
    background: #115e59;
  }

  svg {
    flex-shrink: 0;
  }
`;

const CtaRow = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 0.5rem;
`;

export default function InterviewModesCatalog({
  lead = MODE_PUBLIC_LEAD,
  ctaTo = '/register/candidate',
  ctaLabel = 'Practice a mode',
  showWhen = true,
}) {
  return (
    <Wrap>
      {lead ? <Lead>{lead}</Lead> : null}
      {MODE_FAMILIES.map((family) => (
        <FamilyBlock key={family.id}>
          <FamilyHead>
            <FamilyTitle>{family.title}</FamilyTitle>
            <FamilySub>{family.subtitle}</FamilySub>
          </FamilyHead>
          <Grid>
            {INTERVIEW_MODES.filter((mode) => mode.family === family.id).map((mode) => {
              const Icon = MODE_ICONS[mode.icon] || FiVideo;
              return (
                <Card key={mode.id}>
                  <CardTop>
                    <IconWrap>
                      <Icon size={18} />
                    </IconWrap>
                    <div>
                      <CardTitle>{mode.title}</CardTitle>
                      <Meta>
                        {mode.duration} · {mode.scoring}
                      </Meta>
                    </div>
                  </CardTop>
                  <CardBody>{mode.description}</CardBody>
                  {showWhen ? <When>Use for: {mode.when}</When> : null}
                </Card>
              );
            })}
          </Grid>
        </FamilyBlock>
      ))}
      {ctaTo ? (
        <CtaRow>
          <Cta to={ctaTo}>
            {ctaLabel}
            <FiArrowRight size={18} />
          </Cta>
        </CtaRow>
      ) : null}
    </Wrap>
  );
}
